module.exports = __webpack_public_path__ + "img/tiktok.944a7ac4.png";